import type { DeepPartial } from '@luna/utils-ts';

import type { CardReservationFeatures } from '../../types/CardReservationFeatures';
import type { ReservationFeatures } from '../../types/ReservationFeatures';

export const reservations: DeepPartial<ReservationFeatures> = {
    account: {
        oldReservations: { enabled: true },
    },
    creditCard: {
        oldReservations: { enabled: true },
    },
};

export const cards: DeepPartial<CardReservationFeatures> = {
    bank_card: {
        reservations: { enabled: true },
    },
    credit: {
        reservations: { enabled: true },
    },
};
